<div class="orders-list mt-3">
  <p-table
    #dt
    stripedRows
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [size]="'small'"
    responsiveLayout="scroll"
    [value]="displayOrderNotesGridList"
    [(selection)]="selectedOrderNotesGridListing"
    styleClass="p-datatable-customers no-overfollow ordersLineItems no-wrap table-hover-bg"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [paginator]="false"
    [filterDelay]="0"
    dataKey="id"
    editMode="row"
    selectionMode="multiple"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th></th>
        <th class="col-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="number">Type</th>
        <th class="status" [hidden]="orderType === 'inventory-sales'">
          Purchase Order
        </th>
        <th class="name">Description</th>
        <th class="name">Note</th>
        <th class="name">Created By</th>
        <th class="name">Created date</th>
        <th class="name">Modified By</th>
        <th class="name">Modified date</th>
      </tr>
      <tr>
        <th></th>
        <th></th>
        <th>
          <div class="d-flex" *ngIf="orderNotesGridListing.length">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="type"
              id="type"
              style="max-width: 200px"
              (input)="dt.filter($any($event.target).value, 'type', 'contains')"
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th [hidden]="orderType === 'inventory-sales'">
          <div class="d-flex" *ngIf="orderNotesGridListing.length">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="purchaseOrderId"
              id="purchaseOrderId"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'purchaseOrderId',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex" *ngIf="orderNotesGridListing.length">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="description"
              id="description"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'description', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex" *ngIf="orderNotesGridListing.length">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="note"
              id="note"
              style="max-width: 200px"
              (input)="dt.filter($any($event.target).value, 'note', 'contains')"
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex" *ngIf="orderNotesGridListing.length">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="createdBy"
              id="createdBy"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'createdBy', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-orderNotesGridListing
      let-editing="editing"
      let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pEditableRow]="orderNotesGridListing"
        [pSelectableRow]="orderNotesGridListing"
        [ngClass]="{
          'line-gray': !orderNotesGridListing?.isActive && !isDarkTheme,
          'line-gray-dark':
            orderNotesGridListing?.isActive === true && isDarkTheme,
        }"
        [pSelectableRowDisabled]="!orderNotesGridListing?.isActive">
        <td>
          <div class="eddel-btn d-flex align-items-center">
            <button
              *ngIf="!editing"
              [disabled]="
                !orderNotesGridListing?.isActive || !userBlockedFromEdit
              "
              pButton
              pRipple
              type="button"
              pInitEditableRow
              (click)="onEditRow(orderNotesGridListing)"
              icon="pi pi-pencil"
              class="p-button-rounded p-button-text"></button>
            <button
              *ngIf="editing"
              [disabled]="
                !orderNotesGridListing?.isActive || !userBlockedFromEdit
              "
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              (click)="onRowEditSave(orderNotesGridListing)"
              icon="pi pi-check"
              class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color"></button>
            <button
              *ngIf="editing"
              [disabled]="
                !orderNotesGridListing?.isActive || !userBlockedFromEdit
              "
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              (click)="getSalesOrderNotes(this.saleOrderId)"
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-danger"></button>
          </div>
        </td>
        <td class="col-center">
          <p-tableCheckbox
            [pSelectableRow]="orderNotesGridListing"
            [value]="orderNotesGridListing"></p-tableCheckbox>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-select
                id="currency"
                [(ngModel)]="orderNotesGridListing.type"
                (onChange)="
                  onPurchaseorderchange(
                    orderNotesGridListing.type,
                    orderNotesGridListing.id
                  )
                "
                [options]="typeList"
                optionLabel="name"
                appendTo="body"
                optionValue="name">
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.type }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td [hidden]="orderType === 'inventory-sales'">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-select
                [showClear]="false"
                appendTo="body"
                id="currency"
                [disabled]="
                  disabledField(orderNotesGridListing.type) ||
                  onPurchaseorderstatus
                "
                [(ngModel)]="orderNotesGridListing.purchaseOrderId"
                [options]="purchaseOrderNumber">
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.purchaseOrderId }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                style="width: 5rem"
                [(ngModel)]="orderNotesGridListing.description"
                required />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.description }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                style="width: 5rem"
                [(ngModel)]="orderNotesGridListing.note"
                required />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.note }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>{{ orderNotesGridListing.createdBy }}</td>
        <td>
          <span *ngIf="orderNotesGridListing?.createdDate | hidedynamicsdate">
            {{ orderNotesGridListing.createdDate | date: "MM-dd-yyyy" }}
          </span>
        </td>
        <td>{{ orderNotesGridListing.lastModifiedBy }}</td>
        <td>
          {{ orderNotesGridListing.lastModifiedDate | date: "MM-dd-yyyy" }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
